<template>
  <b-modal
      id="plan-history-modal"
      size="xl"
      v-model="showPlanHistoryModal"
      @hide="closeModal"
      hide-header-close
      hide-footer
      centered
  >
    <b-button variant="close-btn" class='btn-container' @click="closeModal">
      <i class="fas fa-times"></i>
    </b-button>
    <div class="platform-title-text text-center mt-3 mb-3">
      <h5><strong>View Plan History </strong></h5>
      <div class="plan-history-data-wrap mt-3">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Plan Name</th>
              <th>Carrier</th>
              <th>Dates</th>
              <th>Premium Amounts</th>
              <th>Plan Status</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td v-if="!member.plan_history.length" colspan="6" align="center">
                No records found.
              </td>
            </tr>
            <tr
                :id="index"
                v-for="(item, index) in member.plan_history"
                :class="{ termed: item.plan_status.toLowerCase() === 'termed' }"
                :key="index"
            >
              <td>{{item.plan_name_system}} / {{item.plan_tier}}</td>
              <td>{{item.carrier}}</td>
              <td style="text-align: left">
                <div>
                  <strong>Effective Date:</strong>
                  {{item.plan_effective_date}}  <br />
                </div>
                <div>
                  <strong>Termination Date:</strong>
                  {{item.plan_term_date}}  <br />
                </div>
              </td>
              <td>
                ${{item.plan_price}}
              </td>
              <td>{{item.plan_status}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "MemberPlanHistoryModal",
  props: {
    member: {
      required: true,
    },
    showPlanHistoryModal: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      isFlagRender: false
    }
  },
  methods: {
    closeModal() {
      this.$emit("update:showPlanHistoryModal", false);
      this.$emit("onClosedModal");
    }
  }
}
</script>

<style scoped src="@/assets/css/member-plan-history.css"></style>